export default [ 
 
  {
    id: '1',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32191.png',
    symbol: 'OXM',
    name: 'OXM Protocol',
    decimals: '18',
    address: '0x8Ac0B78238678657be5E5264dbCBed0BF3646E1E', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.0...21",
    exchange_rate: '0.00000000021',
    initial_price: "0.00000000005561",
    coinmarketcap: "https://coinmarketcap.com/currencies/oxm-protocol-new/"
  }, 
  {
    id: '2',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33243.png',
    symbol: '$EGGY',
    name: 'EGGY',
    decimals: '18',
    address: '0x849c6a8188b89F9A9757507705263FDFC0F8cd57', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.0...15",
    exchange_rate: '0.000015',
    initial_price: "0.000003827",
    coinmarketcap: "https://coinmarketcap.com/currencies/eggybsc/"
  }, 
  {
    id: '3',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33346.png',
    symbol: 'SEAGULL',
    name: 'SEAGULL SAM',
    decimals: '18',
    address: '0x1FaD8D91F8Ec74183619c258457DDCd54ED5F85d', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.0...29",
    exchange_rate: '0.000029',
    initial_price: "0.000007185",
    coinmarketcap: "https://coinmarketcap.com/currencies/seagull-sam/"
  }, 
  {
    id: '4',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/28592.png',
    symbol: 'AGATA',
    name: 'AgaTech',
    decimals: '18',
    address: '0x18c4AF61DbE6fD55d6470943b4ab8530777d009C', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.0018",
    exchange_rate: '0.0018',
    initial_price: "0.0004493",
    coinmarketcap: "https://coinmarketcap.com/currencies/agatech//"
  }, 
  {
    id: '5',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/20655.png',
    symbol: 'TBAC',
    name: 'BlockAura BEP',
    decimals: '8',
    address: '0x2326C7395d02A8C89a9d7A0b0C1Cf159D49cE51c', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.039",
    exchange_rate: '0.039',
    initial_price: "0.01172",
    coinmarketcap: "https://coinmarketcap.com/currencies/blockaura/"
  }, 
  {
    id: '6',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/9968.png',
    symbol: 'CORGI',
    name: 'Corgi doge',
    decimals: '8',
    address: '0x802C68730212295149f2bEa78C25e2Cf5A05B8A0', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.0...27",
    exchange_rate: '0.0000000027',
    initial_price: "0.0000000007144",
    coinmarketcap: "https://coinmarketcap.com/currencies/corgidoge-real-estate-payment/"
  }, 
  {
    id: '7',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/18899.png',
    symbol: 'WPT',
    name: 'WINPRO',
    decimals: '18',
    address: '0x53c17Ecaa2C662cff7C380729c7E9f7989280b2A', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.025",
    exchange_rate: '0.025',
    initial_price: "0.008239",
    coinmarketcap: "https://coinmarketcap.com/currencies/vrtrinity/"
  },  
  {
    id: '8',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/28256.png',
    symbol: 'VRS',
    name: 'WEAVERS TOKEN',
    decimals: '18',
    address: '0x7cd392a37a36152f5b3afe086a9832ad2ef8d145', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.00017",
    exchange_rate: '0.00017',
    initial_price: "0.00005455",
    coinmarketcap: "https://coinmarketcap.com/currencies/weavers-token/"
  }, 
  {
    id: '10',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/13936.png',
    symbol: 'ARI10',
    name: 'ARI10',
    decimals: '18',
    address: '0x80262F604acAC839724F66846F290A2cC8b48662', 
    vesting_period: '24 Months',
    explorer: 'https://bsscan.io/',
    network: "Binance Smart Chain",
    display_price: "0.0031",
    exchange_rate: '0.0031',
    initial_price: "0.0009974",
    coinmarketcap: "https://coinmarketcap.com/currencies/ari10/"
  }, 
]